var DateTimeFormat = /* @__PURE__ */ ((DateTimeFormat2) => (DateTimeFormat2.USDate = "MM-dd-yyyy", DateTimeFormat2.USDateSlashed = "MM/dd/yyyy", DateTimeFormat2.ISODate = "yyyy-MM-dd", DateTimeFormat2))(DateTimeFormat || {});
export {
  DateTimeFormat
};
//# sourceMappingURL=DateTimeFormat.js.map
